export const shortFieldStyles = {
  wrapper: {
    width: '160px',
    '& .MuiFormLabel-root.Mui-error ': { overflow: 'initial' },
  },
};
